import {Actions} from "@/store/enum/StoreEnums";
import {getRouteGroups} from "@/core/helpers/menu";

/**
 * Menüde `showUserGroup` ile sınırlanmış bölümlerin sayfaları,
 * doğrudan URL ile de açılamasın diye rota seviyesinde korunur.
 *
 * Not: Yetki kontrolünün asıl yeri backend'dir (API zaten 403 döner);
 * buradaki kontrol kullanıcının yetkisiz ekranla karşılaşmasını önler.
 */
export default async function group({to, next, store, nextMiddleWare}) {
    const allowedGroups = getRouteGroups(to.path);

    if (!allowedGroups) {
        return nextMiddleWare ? nextMiddleWare() : next();
    }

    // sayfa doğrudan URL ile açıldıysa oturum henüz yüklenmemiş olabilir
    if (store.getters.isUserAuthenticated && !store.getters.currentUser?.group) {
        await store.dispatch(Actions.VERIFY_AUTH);
    }

    const groupCode = store.getters.currentUser?.group?.code;

    if (groupCode && allowedGroups.includes(groupCode)) {
        return nextMiddleWare ? nextMiddleWare() : next();
    }

    return next({name: "dashboard"});
}
